import { Event } from "../Event";

export class UserIsManagerEvents extends Event {

}